// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer___sgJSI","filtersContainer":"filtersContainer___NgRfe","barcode":"barcode___sRK6U","table":"table___CyhWt"};